module.exports = __webpack_public_path__ + "99da64ea3d500b44588ac5924315e80b.pdf";